import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
export function template() {
  const {
    iconSize
  } = this.helpers.getIconProperties();
  return /* @__PURE__ */ jsx("div", { sel: ".container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    elref: "orgImg",
    align: "middle",
    icon: "mixpanel-logo"
  }, style: {
    height: "".concat(iconSize, "px"),
    width: "".concat(iconSize, "px"),
    color: "white"
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }), this.helpers.isTooltipEnabled() ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: this.attr("tooltip-placement")
  } }, this.attr("tooltip-text")) : null);
}
